export default __webpack_public_path__ + "static/media/bg-retangles-large.50225644.png";